var android = undefined;
export default class JsInterfaceService {
  static enterFullScreen() {
    console.log("enterFullScreen");
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        android = LoanWeb;
        if (typeof android !== "undefined") android.enterFullScreen("");
      } else {
        window.webkit.messageHandlers.enterFullScreen.postMessage("");
      }
    } catch (error) {
      console.log("error enterFullScreen");
      throw error;
    }
  }
  static exitEntryPoint() {
    console.log("exitEntryPoint");
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["closeWebview"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "closeWebview",
        });
      }
    } catch (error) {
      console.log("error exitEntryPoint");
      throw error;
    }
  }
  static requestCamera() {
    console.log("requestCamera");
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["requestCamera"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "requestCamera",
        });
      }
    } catch (error) {
      console.error(error);
      console.log("error requestCamera");
      throw error;
    }
  }
  static openLfmStatusPage() {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["openLFMProductionStatusPage"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "openLFMProductionStatusPage",
        });
      }
    } catch (error) {
      console.error(error);
      console.log("error openLfmStatusPage");
      throw error;
    }
  }

  static openLFMProductionShelf() {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["openLFMProductionShelf"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "openLFMProductionShelf",
        });
      }
    } catch (error) {
      console.error(error);
      console.log("error openLFMProductionShelf");
      throw error;
    }
  }

  static requestGallery() {
    console.log("requestGallery");
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    try {
      if (isAndroid) {
        window.JSBridge["requestGallery"]?.();
      } else {
        window.webkit.messageHandlers.observer.postMessage({
          command: "requestGallery",
        });
      }
    } catch (error) {
      console.error(error);
      console.log("error requestGallery");
      throw error;
    }
  }
}
